module.exports = __webpack_public_path__ + "media/images/landing/eno/product-2-584412ecf2230e7a49bf5721e71dfa60.png";